import { getApiErrorCode } from '../../utils/apiErrorCode';

const SERVICE_PACKAGE_API_ERROR_CODES = [
  'InvalidServicePackageData',
  'ServicePackageNotFound',
  'ServicePackageInactive',
  'CustomerServicePackageAlreadyActive',
  'CustomerServicePackageNotFound',
  'StorePayOnBookingDisabled',
  'PlanUpgradeRequired',
];

/** The i18n key describing a failed service package request, or the fallback key. */
export const getServicePackageErrorKey = (error, fallbackKey) => {
  const code = getApiErrorCode(error);
  return SERVICE_PACKAGE_API_ERROR_CODES.includes(code)
    ? `servicePackagesManagement.apiErrors.${code}`
    : fallbackKey;
};

export default getServicePackageErrorKey;
